import {Component, OnInit} from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';


@Component({
  standalone: false,
  selector: 'xform-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  constructor(
    public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit() {
  }

}
